// src/lib/react-query/queryClient.js
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10 * 60 * 1000,   // 10 دقائق
      cacheTime: 60 * 60 * 1000,   // 60 دقيقة
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      retry: 1,
      keepPreviousData: true,
    },
    mutations: {
      retry: 0,
    },
  },
});
